export interface MaporiumGuidelinesStyle {
  strokeStyle: string;
  lineWidth: number;
  lineDash: number[];
  geometricGuidelineRange: number;
}

export interface MaporiumGridOptions {
  drawGrid: boolean;
  gridSpacing: number;
  gridColor: string;
  lineWidth: number;
  gridStackOrder: number;
  panGrid: boolean;

  snapToGridDuringDrag: boolean;
  snapToAlignmentLocationDuringDrag: boolean;
  geometricGuideline: boolean;

  guidelinesStackOrder: number;
  guidelinesTolerance: number;
  guidelinesStyle: MaporiumGuidelinesStyle;
}

export const MAPORIUM_GRID_DEFAULTS: MaporiumGridOptions = {
  drawGrid: false,
  gridSpacing: 20,
  gridColor: '#dedede',
  lineWidth: 1,
  gridStackOrder: 0,
  panGrid: true,

  snapToGridDuringDrag: false,
  snapToAlignmentLocationDuringDrag: false,
  geometricGuideline: false,

  guidelinesStackOrder: 4,
  guidelinesTolerance: 2,
  guidelinesStyle: {
    strokeStyle: '#8b7d6b',
    lineWidth: 1,
    lineDash: [],
    geometricGuidelineRange: 400,
  },
};

export function mergeOptions(
  base: MaporiumGridOptions,
  patch?: Partial<MaporiumGridOptions>
): MaporiumGridOptions {
  return {
    ...base,
    ...patch,
    guidelinesStyle: { ...base.guidelinesStyle, ...patch?.guidelinesStyle },
  };
}
